import {
    Dashboard,
    Settings,
    Public,
    Flag,
    People,
    Category,
    Commute,
    DesignServices,
    Store,
    Tour,
    Inventory2,
    ViewModule,
    Person,
    Security,
    AttachMoney,
    MonetizationOn,
    Payment,
    SupportAgent,
    Flight,
    FlightTakeoff,
} from '@mui/icons-material';


export const sidebarItems = [
    {
        key: 'dashboard',
        label: { en: 'Dashboard', ar: 'لوحة التحكم' },
        path: '/dashboard',
        icon: Dashboard,
    },
    {
        key: 'setting',
        label: { en: 'Setting', ar: 'الأعدادات' },
        path: '/setting',
        icon: Settings,
    },
    {
        key: 'airlines',
        label: { en: 'Airlines', ar: 'شركات الطيران' },
        path: '/airlines',
        icon: Flight,
    },
    {
        key: "airports",
        label: {
            ar: "المطارات",
            en: "Airports",
        },
        icon: FlightTakeoff,
        path: "/airports",
    },
    {
        key: 'countries',
        label: { en: 'Countries', ar: 'الدول' },
        path: '/countries',
        icon: Public,
    },
    {
        key: 'cities',
        label: { en: 'Cities', ar: 'المدن' },
        path: '/cities',
        icon: Commute,
    },
    {
        key: 'agents',
        label: { en: 'Agents', ar: 'الوكلاء' },
        path: '/agents',
        icon: SupportAgent,
    },
    {
        key: 'currencies',
        label: { en: 'Currencies', ar: 'العملات' },
        path: '/currencies',
        icon: AttachMoney,
    },
    {
        key: 'nationalities',
        label: { en: 'Nationalities', ar: 'الجنسيات' },
        path: '/nationalities',
        icon: Flag,
    },
    {
        key: 'paxTypes',
        label: { en: 'Pax Types', ar: 'أنواع الركاب' },
        path: '/pax-types',
        icon: People,
    },
    {
        key: 'productTypes',
        label: { en: 'Product Types', ar: 'أنواع المنتجات' },
        path: '/product-types',
        icon: Inventory2,
    },
    {
        key: 'termOfPayments',
        label: { en: 'Term of Payments', ar: 'شروط الدفع' },
        path: '/term-of-payments',
        icon: Payment,
    },
    {
        key: 'pricingUnits',
        label: { en: 'Pricing Units', ar: 'وحدات التسعير' },
        path: '/pricing-units',
        icon: MonetizationOn,
    },
    {
        key: 'transportations',
        label: { en: 'Transportations', ar: 'وسائل النقل' },
        path: '/transportations',
        icon: Commute,
    },
    {
        key: 'categories',
        label: { en: 'Categories', ar: 'التصنيفات' },
        path: '/categories',
        icon: Category,
    },
    {
        key: 'packages',
        label: { en: 'Tour Options', ar: 'خيارات الجولات' },
        path: '/packages',
        icon: Tour,
    },
    {
        key: 'services',
        label: { en: 'Services', ar: 'الخدمات' },
        path: '/services',
        icon: DesignServices,
    },
    {
        key: 'suppliers',
        label: { en: 'Suppliers', ar: 'الموردون' },
        path: '/suppliers',
        icon: Store,
    },
    {
        key: 'products',
        label: { en: 'Products', ar: 'المنتجات' },
        path: '/products',
        icon: Inventory2,
    },
    {
        key: 'hotelMealPlans',
        label: { en: 'Hotel Meal Plans', ar: 'خطط الوجبات' },
        path: '/hotel-meal-plans',
        icon: Inventory2,
    },
    {
        key: 'hotelRatings',
        label: { en: 'Hotel Ratings', ar: 'تصنيفات الفنادق' },
        path: '/hotel-ratings',
        icon: Inventory2,
    },
    {
        key: 'hotelRoomCategories',
        label: { en: 'Room Categories', ar: 'أنواع الغرف' },
        path: '/hotel-room-categories',
        icon: Inventory2,
    },
    {
        key: 'hotelExtras',
        label: { en: 'Hotel Extras', ar: 'إضافات الفنادق' },
        path: '/hotel-extras',
        icon: Inventory2,
    },
    {
        key: 'programs',
        label: { en: 'Programs', ar: 'البرامج' },
        path: '/programs',
        icon: ViewModule,
    },
    {
        key: 'users',
        label: { en: 'Users', ar: 'المستخدمون' },
        path: '/users',
        icon: Person,
    },
    {
        key: 'roles',
        label: { en: 'Roles', ar: 'الأدوار' },
        path: '/roles',
        icon: Security,
    },
];
/**
 * جميل الآن ابدأ ببناء ال Currencies بنفس الستركتشر والديزاين باتيرن واللوجيك ونفس طريقة الكود التي نعمل بها دون اي تعديل 
 * */ 